import ListCache from './_ListCache';

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

export default stackClear;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_stackClear.js
// module id = 307
// module chunks = 0